export const xSmallBreakpoint = 480;
export const smallBreakpoint = 720;
export const mediumBreakpoint = 1024;
export const largeBreakpoint = 1366;

/**
 * Only execute given css in mobile mode (browser width < 480px)
 */
export function mobile(css: string): string {
  return `
    @media (max-width: ${xSmallBreakpoint - 1}px) {
      ${css}
    }
  `;
}

/**
 * Only execute given css in tablet mode (browser width < 1024px and > 480px)
 */
export function tablet(css: string): string {
  return `
    @media (min-width: ${xSmallBreakpoint}px) and (max-width: ${mediumBreakpoint - 1}px) {
      ${css}
    }
  `;
}

/**
 * Only execute given css in desktop mode (browser width >= 1024px)
 */
export function desktop(css: string): string {
  return `
    @media (min-width: ${mediumBreakpoint}px) {
      ${css}
    }
  `;
}
